import { setPlaceOrderFallbackRoute } from '../helpers/checkout';

const START_CANCEL_TRANSACTION = 'START_CANCEL_TRANSACTION';
const END_CANCEL_TRANSACTION = 'END_CANCEL_TRANSACTION';
const START_WORLDPAY_MODAL = 'START_WORLDPAY_MODAL';
const START_GENERIC_PAYMENT_MODAL = 'START_GENERIC_PAYMENT_MODAL';
const RECEIVE_PAYMENT_RESPONSE = 'RECEIVE_PAYMENT_RESPONSE';
const PLACE_ORDER = 'PLACE_ORDER';
const ORDER_CREATED = 'ORDER_CREATED';

const cancelTransaction = () => ({
  type: START_CANCEL_TRANSACTION,
});

const startWorldPayModal = (value) => ({
  type: START_WORLDPAY_MODAL,
  value,
});

const endCancelTransaction = () => ({
  type: END_CANCEL_TRANSACTION,
});

const placeOrder = (paymentMethod, fallbackRoute) => {
  setPlaceOrderFallbackRoute(fallbackRoute);

  return { type: PLACE_ORDER, paymentMethod };
};

const receivePaymentResponse = (method, action, data) => ({
  type: RECEIVE_PAYMENT_RESPONSE,
  method,
  action,
  data,
});

const orderCreated = (orderNumber) => ({ type: ORDER_CREATED, orderNumber });

export {
  START_CANCEL_TRANSACTION,
  END_CANCEL_TRANSACTION,
  START_WORLDPAY_MODAL,
  START_GENERIC_PAYMENT_MODAL,
  RECEIVE_PAYMENT_RESPONSE,
  PLACE_ORDER,
  ORDER_CREATED,
  startWorldPayModal,
  cancelTransaction,
  endCancelTransaction,
  receivePaymentResponse,
  placeOrder,
  orderCreated,
};
